import React from 'react';

const VARIANTS = {
  green: 'badge-green',
  amber: 'badge-amber',
  red: 'badge-red',
  blue: 'badge-blue',
  neutral: 'badge-neutral',
};

// Ports the mockup's badge() heuristic: picks a color from status-ish text.
export function statusVariant(text) {
  const t = String(text ?? '').toLowerCase();
  if (
    t.includes('active') || t.includes('accepted') || t.includes('ok') || t.includes('ready') ||
    t.includes('live') || t.includes('synced') || t.includes('acknowledged') || t.includes('complete') ||
    t.includes('connected')
  ) return 'green';
  if (
    t.includes('pending') || t.includes('planned') || t.includes('watch') || t.includes('low') ||
    t.includes('clean') || t.includes('partial') || t.includes('api') || t.includes('high load') ||
    t.includes('yellow')
  ) return 'amber';
  if (
    t.includes('red') || t.includes('delayed') || t.includes('closed') || t.includes('not started') ||
    t.includes('contam') || t.includes('high')
  ) return 'red';
  if (t.includes('green') || t.includes('exercise')) return 'blue';
  return 'neutral';
}

// Readiness levels have their own fixed color mapping and must never go through
// statusVariant()'s auto-detect — that heuristic maps any "active"-containing string to
// green (correct for ActivityStatus's "Active" staff member), which is wrong here since
// readiness Active means "engaged on a live incident" (should read as urgent/red).
const READINESS_VARIANTS = { Normal: 'green', Alert: 'amber', Standby: 'blue', Active: 'red' };
export function readinessVariant(level) {
  return READINESS_VARIANTS[level] || 'neutral';
}

export default function Badge({ variant, children, className = '' }) {
  const resolved = variant || statusVariant(children);
  return <span className={`badge ${VARIANTS[resolved] || VARIANTS.neutral} ${className}`}>{children}</span>;
}
